{
  "common": {
    "yes": "Da",
    "no": "Ne",
    "next": "Sledeće",
    "previous": "Prethodno",
    "submit": "Pošalji",
    "actions": "Akcije",
    "noData": "Nema podataka",
    "filters": "Filteri",
    "page": "Stranica",
    "otherInputPlaceholder": "Molimo navedite...",
    "otherAnswerLabel": "Drugi odgovor",
    "otherNumberPlaceholder": "Unesite broj...",
    "performingAction": "Izvršavanje akcije...",
    "otherNumericInputLabel": "Broj korisnika pogođenih incidentom",
    "errors": {
      "email": "Polje mora biti validna email adresa",
      "minlength": "Polje mora imati najmanje {{requiredLength}} karaktera. Trenutna dužina je {{actualLength}}",
      "required": "Polje je obavezno",
      "maxlength": "Polje može imati najviše {{requiredLength}} karaktera. Trenutna dužina je {{actualLength}}",
      "pattern": "Polje mora odgovarati šablonu {{requiredPattern}}",
      "min": "Polje mora biti najmanje {{min}}",
      "max": "Polje može biti najviše {{max}}",
      "websitePattern": "Molimo unesite validan URL sajta (npr. https://example.com)",
      "durationPattern": "Molimo unesite validno trajanje u formatu {{durationLabel}}",
      "pageNotFound": "Nema aktivnih formi",
      "pageNotFoundDescription": "Nema aktivnih formi. Molimo, pokušajte ponovno kasnije ili kontaktirajte podršku.",
      "startsWith": "Polje mora početi sa {{startsWith}} i sadržati samo cifre",
      "minDate": "Datum mora biti posle {{minDate}}",
      "maxDate": "Datum mora biti pre {{maxDate}}",
      "step": "Polje mora biti umnožak od {{step}}",
      "mustMatchPassword": "Lozinke se ne podudaraju",
      "strongPassword": "Lozinka mora biti najmanje 8 karaktera, sadržavati najmanje jedan veliki broj, jedan mali broj i jedan poseban karakter"
    },
    "toast": {
      "success": "Uspeh",
      "warning": "Upozorenje",
      "error": "Greška",
      "languageChanged": "Jezik je promenjen"
    },
    "enums": {
      "incidentStatus": {
        "status": "Status",
        "REPORTED": "Prijavljen incident",
        "REPORT_SUBMITTED": "Dostavljeno dodatno obaveštenje",
        "ADDITIONAL_REPORT_SUBMITTED": "Dostavljen dodatni izveštaj",
        "CLOSED": "Dostavljen završni izveštaj",
        "DISMISSED": "Otklonjen"
      },
      "mediaType": {
        "UNKNOWN": "Nepoznato",
        "IMAGE": "Slika",
        "VIDEO": "Video",
        "SVG": "SVG",
        "AUDIO": "Audio",
        "PDF": "PDF",
        "WORD": "Word dokument",
        "ARCHIVE": "Arhiva"
      }
    },
    "reportType": {
      "title": "Šta prijavljujete?",
      "description": "Izaberite vrstu prijave da biste otvorili odgovarajući formular.",
      "incident": "Incident",
      "incidentDescription": "Incident koji se dogodio u IKT sistemu.",
      "avoided": "Izbegnuti incident",
      "avoidedDescription": "Incident koji je sprečen pre nego što je nastupio.",
      "change": "Promeni vrstu prijave",
      "downloadPdf": "Preuzmi PDF obrazac"
    }
  },
  "auth": {
    "forgotPassword": "Zaboravili ste lozinku?",
    "login": "Prijavite se",
    "returnToLogin": "Vratite se na prijavu",
    "sendEmail": "Pošaljite email",
    "resetPassword": "Resetujte lozinku",
    "register": "Registrujte se",
    "alreadyHaveAccount": "Već imate nalog?",
    "otpCode": "OTP kod",
    "otpExpiresIn": "Ističe za",
    "otpExpired": "OTP kod je istekao, molimo pokušajte ponovo",
    "setPassword": {
      "title": "Postavite novu lozinku",
      "description": "Izaberite sopstvenu lozinku da biste nastavili. Nakon toga ćete se ponovo prijaviti sa njom.",
      "submit": "Sačuvajte lozinku",
      "signOut": "Odjavite se"
    },
    "fields": {
      "name": "Ime",
      "email": "Email",
      "password": "Lozinka",
      "newPassword": "Nova lozinka",
      "repeatPassword": "Ponovite lozinku"
    }
  },
  "sidebar": {
    "reportIncident": "Prijavi incident",
    "signOut": "Odjavi se",
    "viewReportedIncidents": "Pregled prijavljenih incidenata",
    "editProfile": "Pregledaj profil",
    "avoidedIncidents": "Pregled izbegnutih incidenata"
  },
  "languagePicker": {
    "en": "English",
    "sr": "Srpski (latinica)",
    "cyr": "Српски (ћирилица)"
  },
  "languages": {
    "en": "Engleski",
    "sr": "Srpski (latinica)",
    "cyr": "Srpski (ćirilica)"
  },
  "submittedForms": {
    "single": {
      "noFields": "Nema polja za prikaz"
    }
  },
  "confirmations": {
    "delete": "Obrisati ovu stavku?",
    "submitForm": "Da li ste sigurni da želite da pošaljete formular?"
  },
  "primeng": {
    "multiselect": {
      "selectedItemsLabel": "{0} stavke izabrane"
    }
  },
  "buttons": {
    "no": "Otkaži",
    "yes": "Potvrdi"
  }
}
